module.exports = {"450881101":"木乐镇","450881102":"木圭镇","450881103":"石咀镇","450881104":"油麻镇","450881105":"社坡镇","450881106":"罗秀镇","450881107":"麻垌镇","450881108":"社步镇","450881109":"下湾镇","450881110":"木根镇","450881111":"中沙镇","450881113":"大洋镇","450881114":"大湾镇","450881115":"白沙镇","450881116":"石龙镇","450881117":"蒙圩镇","450881118":"西山镇","450881119":"南木镇","450881120":"江口镇","450881121":"金田镇","450881122":"紫荆镇","450881200":"马皮乡","450881202":"寻旺乡","450881203":"罗播乡","450881204":"厚禄乡","450881206":"垌心乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/450881.json
// module id = 2133
// module chunks = 0